<template>
  <div id="home">
    <div v-if="getUser()==='' || (getUser()!=='' && !userExists())">
      <div class="outerHome noselect">
        <img src="../assets/back.jpg" style="width:100%; position: absolute; top: 0px; width: 100%; height: auto; left:0px; ">

        <div >
          <b-jumbotron header="Flutr" lead="Welcome to flutr butterfly repository" class="heading">
          </b-jumbotron>
        </div>
        <div>
          <div class="mt-3">
            <b-row class="cards">
              <b-col v-for="butterfly of butterflies.slice(randomButterfly(), randomNum+3)" v-bind:key="butterfly['.key']">
                <b-card bg-variant="dark" no-header text-variant="white" class="text-center" >
                  <h4>Butterfly Showcase</h4>
                  <div>
                    <h5>{{butterfly.scientificName}}</h5>
                    <b-img-lazy v-if="butterfly.url" fluid :src="butterfly.url"></b-img-lazy>
                    <img v-else src="../assets/unknown.png" fluid alt="No image" class="mb-2 responsive">
                    <p>{{butterfly.funFact}}</p>
                  </div>
                </b-card>
              </b-col>
            </b-row>
            <b-row v-if="butterflies.length==0">
              <b-card bg-variant="dark" no-header text-variant="white" class="text-center" >
                <h4>Butterfly Showcase</h4>
                <p>No butterflies in the system</p>
              </b-card>
            </b-row>
          </div>
        </div>
      </div>
    </div>

    <div v-else>
      <div class="outerHome noselect" v-for="user of users.filter(thisUser)" v-bind:key="user['.key']">
        <img :src="user.url" style="width:100%; position: absolute; top: 0px; width: 100%; height: auto; left:0px">
        <div>
          <b-jumbotron :header="user.title?user.title:'Title'" :lead="user.titleText?user.titleText:'Title text'" class="heading">
          </b-jumbotron>
        </div>
        <div>
          <div class="mt-3">
            <b-row class="cards">
              <b-col>
                <b-card bg-variant="light" no-header class="text-center" >
                  <h4>Note from Admin</h4>
                  <b-card-text>{{user.note?user.note:'Note from admin will be shown here'}}</b-card-text>
                </b-card>
              </b-col>

              <b-col v-if="butterflies.filter(thisUser).length>0">
                <b-card bg-variant="dark" no-header text-variant="white" class="text-center">
                  <h4>Butterfly Showcase</h4>
                  <div v-for="butterfly of butterflies.filter(thisUser).slice(randomButterfly(), randomNum+1)" v-bind:key="butterfly['.key']">
                    <h5>{{butterfly.scientificName}}</h5>
                    <b-img-lazy v-if="butterfly.url" fluid :src="butterfly.url"></b-img-lazy>
                    <img v-else src="../assets/unknown.png" fluid alt="No image" class="mb-2 responsive">
                    <p>{{butterfly.funFact}}</p>
                  </div>
                </b-card>
              </b-col>
              <b-col v-else>
               <b-card bg-variant="dark" no-header text-variant="white" class="text-center">
                <h4>Butterfly Showcase</h4>

                <b-card-text>No butterflies in the system</b-card-text>
              </b-card>
            </b-col>

            <b-col>
              <b-card bg-variant="light" no-header class="text-center" >
                <h4>Other Info</h4>
                <b-card-text>{{user.other?user.other:'Other info will be shown here'}}</b-card-text>
              </b-card>
            </b-col>
          </b-row>

        </div>
      </div>
    </div>
  </div>
</div>
</template>



<style>
.outerHome{
  padding: 50px 50px 150px 50px;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: center; 
  background-size: cover;
}

.heading{
  opacity: 0.9;
}

.responsive {
  width: 100%;
  height: auto;
}

.cards{
  opacity: 0.9;
}

.noselect {
  -webkit-touch-callout: none; 
  -webkit-user-select: none; 
  -khtml-user-select: none; 
  -moz-user-select: none; 
  -ms-user-select: none; 
  user-select: none; 
}

</style>

<script>
import { butterflyRef } from '../firebase'
import { userRef } from '../firebase'
export default {
  name: 'home',
  data () {
    return {
      butterflies: [],
      users: [],
      randomNum: 0
    }
  },
  firebase: {
    butterflies: butterflyRef,
    users: userRef
  },
  methods: {
    randomButterfly(){
      this.randomNum = Math.floor(Math.random()*this.butterflies.filter(this.thisUser).length);
      return this.randomNum;
    },
    getUser(){
      return this.$parent.activeUser?this.$parent.activeUser.name:'';
    },
    thisUser(user){
      return user.user == this.getUser()?user:null
    },
    userExists(){
      var exists = false;
      for(let i = 0; i<this.users.length; i++){
        if(this.users[i].user == this.getUser()){
          exists = true;
        }
      }

      return exists
    }
  }
}
</script>
